import { localEventDayKey } from "@/lib/agendaEventRange";

/** A task deadline is a reviewed civil date; its stored UTC time is not a local appointment. */
export function taskDueDay(dueDate: string | null | undefined): string | null {
  return dueDate ? dueDate.slice(0, 10) : null;
}

/** ISO week in the device's local calendar, queried using the stored civil-date representation. */
export function taskWeekRange(now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  start.setDate(start.getDate() - (start.getDay() + 6) % 7);
  const end = new Date(start); end.setDate(end.getDate() + 6);
  const firstDay = localEventDayKey(start.toISOString());
  const lastDay = localEventDayKey(end.toISOString());
  return { firstDay, lastDay, start: firstDay + "T00:00:00.000Z", end: lastDay + "T23:59:59.999Z" };
}

export function taskDueWeekday(dueDate: string, locale: string): string {
  return new Date(taskDueDay(dueDate) + "T00:00:00.000Z")
    .toLocaleDateString(locale, { weekday: "short", timeZone: "UTC" });
}
